<p-card>
  <app-tipo-proc-doc-frm></app-tipo-proc-doc-frm>
  <div class="p-fluid p-grid m-t-3">
    <div class="p-field p-col-12 p-md-6">
      <button pButton (click)="frm.salvar()" class="p-button-success" label="Salvar" ></button>
    </div>
    <div class="p-col-12 p-lg-6">
      <button pButton appBotaoVoltar class="p-button-secondary" label="Voltar"></button>
    </div>
  </div>
</p-card>
